var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    transform: "translate(-1095 -454)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.5,
    transform: "rotate(60 169.59219981 1194.02972925)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1120.99977185 485.85652423a16 16 0 0 1-16-27.71281292c-.00036791.30736275 16.03660254 27.57621038 16 27.71281292Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1111.458887 460.3098017c1.80958413-.64739344 5.33695625-.19822204 6.69004512 1.70866036"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.94f894df40f315663ba05cb62382cda1.svg";
export { ForwardRef as ReactComponent };